import { Injectable, Provider } from '@angular/core'
import { TrackingEvent } from './tracking'

/**
 * @ftr/foundation should not understand anything about the implementation of our analytics,
 * but sometimes we do want tracking events on things like buttons/validation etc.
 *
 * You may not need this. For simple click tracking, add a data-track tag to your button's html.
 * See: https://www.notion.so/ftrlabs/Analytics-and-Tracking-293e8c890b5347278a15c77d4af38a8f#74e216fc575b44b68f0fbb42a37f13b2
 */
@Injectable({ providedIn: 'root' })
export abstract class TrackingService {
  abstract track(data: TrackingEvent): void
}

const DUMMY_TRACKING_SERVICE = { track: () => undefined }

export function provideTrackingService(): Provider {
  return { provide: TrackingService, useValue: DUMMY_TRACKING_SERVICE }
}
